import dayjs from 'dayjs';

import { axiosInstanceWithoutErrorModal } from '../assets/utils/axiosInstance';

type ItemType = {
  id: number,
  report: string,
  name: string,
  associated_department: number,
  notification_reason: string,
  date_informed_at: string,
  is_deleted: boolean
};


type FetchInformedIndividualsType = {
  count: number,
  next: string | null,
  previous: string | null,
  results: Array<ItemType>
};


type PostInformedIndividualType = {
  report: string,
  name: string,
  associatedDepartment: string,
  notificationReason: string,
  dateInformed: string
};

type PostInformedIndividualResponseType = {
  id: number,
  report: string,
  name: string,
  associated_department: number,
  notification_reason: string,
  date_informed_at: string,
  is_deleted: boolean
};

type PatchInformedIndividualsType = {
  id: number,
  name: string,
  associated_department: number,
  notification_reason: string,
  date_informed_at: string,
  is_deleted?: boolean
};

type PatchInformedIndividualsResponseType = {
  id: number,
  report: string,
  name: string,
  associated_department: number,
  notification_reason: string,
  date_informed_at: string,
  is_deleted: boolean
};

type ModifiedItemType = {
  id: number,
  report: string,
  name: string,
  associated_department: number,
  notification_reason: string,
  date_informed_at: string,
  is_deleted: boolean,
  has_error?: boolean
  errors?: {
    name: boolean,
    associated_department: boolean,
    notification_reason: boolean,
    date_informed: boolean
  }
};

const patchInformedIndividuals = async (items: Array<PatchInformedIndividualsType>): Promise<{ data: Array<PatchInformedIndividualsResponseType> }> => {
  
  return new Promise((resolve, reject) => {

    const formatItems = JSON.parse(JSON.stringify(items));
    if ( formatItems.length > 0 ) {
      formatItems.map( (fi: ModifiedItemType, key: number)=> {

        const {
          is_deleted: isDeleted,
          errors,
          has_error: hasError,
          report,
          date_informed_at: dateInformedAt,
          ...otherProps
        } = fi;


        const newDateInformedAt = dayjs(dateInformedAt).format('YYYY-MM-DD');

        formatItems[key] = {
          date_informed_at: newDateInformedAt,
          ...otherProps,
        };
      });

      axiosInstanceWithoutErrorModal().patch<Array<PatchInformedIndividualsResponseType>>('/informed-individuals/update', formatItems).then((response) => {
        resolve(response);
      }).catch(e => {
        reject(e);
      });

    } else {
      reject('An error occured');
    }

    
  });
};

const deleteInformedIndividual = async (id: number): Promise<{ data:  Array<PatchInformedIndividualsType> }> => {
  return new Promise((resolve, reject) => {
    const deleteItems = [{
      id,
      is_deleted: true,
    }];

    const formatItems = JSON.parse(JSON.stringify(deleteItems));
    
    axiosInstanceWithoutErrorModal().patch<Array<PatchInformedIndividualsResponseType>>('/informed-individuals/update', formatItems).then((response) => {
      resolve(response);
    }).catch(e => {
      reject(e);
    });



  });
};

const postInformedIndividual = async (item: PostInformedIndividualType): Promise<{ data: PostInformedIndividualResponseType }> => {

  return new Promise((resolve, reject) => {

    let formatItem = JSON.parse(JSON.stringify(item));
    formatItem = {
      report: item.report,
      name: item.name,
      associated_department: parseInt(item.associatedDepartment),
      date_informed_at: item.dateInformed,
      notification_reason: item.notificationReason,
    };

    axiosInstanceWithoutErrorModal().post<PostInformedIndividualResponseType>('/informed-individuals', formatItem).then((response) => {
      resolve(response);
    }).catch(e => {
      reject(e);
    });

  });

};





const fetchInformedIndividuals = async (page: number, reportId: string, url?: string | null): Promise<{ data: FetchInformedIndividualsType }> => {

  const finalUrl = (typeof url != 'undefined' && url != null) ? url : `/informed-individuals?page=${page}&report_id=${reportId}`;
  try {
    const response = await axiosInstanceWithoutErrorModal().get<FetchInformedIndividualsType>(finalUrl);
    return await Promise.resolve(response);
  } catch (e) {
    return Promise.reject(e);
  }
};


const informedIndividualsService = {
  fetchInformedIndividuals,
  postInformedIndividual,
  patchInformedIndividuals,
  deleteInformedIndividual,
};
  
export default informedIndividualsService;